const en = {
  // Navbar
  "nav.myVideos": "My Videos",
  "nav.users": "Users",
  "nav.upload": "Upload",
  "nav.profile": "Profile",
  "nav.signOut": "Sign out",
  "nav.signIn": "Sign in",

  // Common
  "common.loading": "Loading...",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.deleting": "Deleting...",
  "common.adding": "Adding...",
  "common.unknown": "unknown",
  "common.you": "You",
  "common.audio": "Audio",
  "common.default": "default",

  // Theme
  "theme.system": "System",
  "theme.light": "Light",
  "theme.dark": "Dark",

  // Language
  "language.en": "English",
  "language.zh_HK": "繁體中文",
  "language.zh_CN": "简体中文",

  // Status
  "status.NEW": "New",
  "status.QUEUED": "Queued",
  "status.PROCESSING": "Processing",
  "status.READY": "Ready",
  "status.FAILED": "Failed",

  // Visibility
  "visibility.public": "Public",
  "visibility.private": "Private",
  "visibility.protected": "Protected",

  // Monetization
  "monetization.free": "Free",
  "monetization.sub": "Subscription",
  "monetization.svod": "SVOD",
  "monetization.tvod": "TVOD",
  "monetization.ads": "Ads",

  // Time
  "time.justNow": "just now",
  "time.minuteAgo": "{n} minute ago",
  "time.minutesAgo": "{n} minutes ago",
  "time.hourAgo": "{n} hour ago",
  "time.hoursAgo": "{n} hours ago",
  "time.dayAgo": "{n} day ago",
  "time.daysAgo": "{n} days ago",
  "time.monthAgo": "{n} month ago",
  "time.monthsAgo": "{n} months ago",
  "time.yearAgo": "{n} year ago",
  "time.yearsAgo": "{n} years ago",

  // Login page
  "login.title": "Sign in",
  "login.email": "Email",
  "login.password": "Password",
  "login.submit": "Sign in",
  "login.signingIn": "Signing in...",
  "login.hint": "Sign in with the admin account configured via ADMIN_EMAIL / ADMIN_PASSWORD.",

  // Home page
  "home.search": "Search videos or tags",
  "home.noVideosMatch": "No videos match your search",
  "home.noVideosYet": "No videos yet",
  "home.uploadToStart": "Upload a video to get started.",
  "home.loadFailed": "Failed to load videos: {error}",

  // Upload page
  "upload.title": "Upload a video",
  "upload.noPermission": "You don't have permission to upload videos. Sign in as a publisher or admin.",
  "upload.titleLabel": "Title",
  "upload.videoFile": "Video file",
  "upload.monetization": "Monetization",
  "upload.requiredTier": "Required tier (optional)",
  "upload.requiredTierPlaceholder": "e.g. standard",
  "upload.visibility": "Visibility",
  "upload.visibility.public.desc": "Everyone in your tenant can see and play this video",
  "upload.visibility.private.desc": "Only you can see and play this video",
  "upload.visibility.protected.desc": "Only you and the users you select below can see and play this video",
  "upload.grantAccess": "Grant access to",
  "upload.loadingUsers": "Loading users...",
  "upload.selectUser": "Select at least one user (or switch to Private)",
  "upload.renditionProfiles": "Rendition profiles",
  "upload.tags": "Tags (optional)",
  "upload.tagPlaceholder": "Type a tag and press Enter",
  "upload.step.details": "Details",
  "upload.step.upload": "Upload",
  "upload.step.publish": "Publish",
  "upload.step.ready": "Ready",
  "upload.uploading": "Uploading... {percent}%",
  "upload.ingesting": "Status: {status} — processing will continue in the background. This page will update when done.",
  "upload.publish": "Publish video",
  "upload.processing": "Processing...",
  "upload.ready": "Your video is ready!",
  "upload.watchNow": "Watch now",
  "upload.backToHome": "Back to home",
  "upload.transcodeFailed": "Transcoding failed. See the asset's job details on the watch page.",
  "upload.addTag": "Add tag",
  "upload.titlesLabel": "Titles",
  "upload.file": "file",
  "upload.files": "files",
  "upload.fillAllTitles": "Please fill in all titles.",

  // My Videos page
  "myVideos.title": "My Videos",
  "myVideos.uploadNew": "Upload new video",
  "myVideos.empty": "You haven't uploaded any videos yet",
  "myVideos.uploadFirst": "Upload your first video",
  "myVideos.noPermission": "You don't have permission to manage videos.",
  "myVideos.processing": "Processing",
  "myVideos.processingNote": "These are being transcoded",
  "myVideos.published": "Published",
  "myVideos.publishedNote": "Live and viewable",
  "myVideos.drafts": "Drafts (not uploaded)",
  "myVideos.draftsNote": "Created but source not uploaded — delete to clean up",
  "myVideos.failed": "Failed",
  "myVideos.failedNote": "Transcoding failed — delete to remove broken videos",

  // Watch page
  "watch.processing": "Queued for processing...",
  "watch.transcoding": "Transcoding in progress...",
  "watch.failed": "This video failed to process",
  "watch.processingNote": "This video is still being processed. It will start playing automatically once transcoding completes.",
  "watch.renditions": "Renditions",
  "watch.audioTracks": "Audio tracks",
  "watch.noAudioTracks": "No audio tracks",
  "watch.processingJobs": "Processing jobs",
  "watch.editVisibility": "Edit visibility",
  "watch.delete": "Delete",
  "watch.channel": "Channel",
  "watch.noTags": "No tags",
  "watch.deleteTitle": "Delete video",
  "watch.deleteMessage": "Are you sure you want to delete \"{title}\"? This permanently removes the video and all its files.",
  "watch.editVisibilityTitle": "Edit visibility",
  "watch.grantAccess": "Grant access to",
  "watch.attachAudio": "Attach audio",
  "watch.attaching": "Attaching...",

  // Users page
  "users.title": "User Management",
  "users.onlyAdmin": "Only administrators can manage users.",
  "users.addNew": "Add a new user",
  "users.email": "Email",
  "users.password": "Password",
  "users.role": "Role",
  "users.role.viewer": "Viewer",
  "users.role.publisher": "Publisher",
  "users.role.admin": "Admin",
  "users.addUser": "Add user",
  "users.users": "Users ({n})",
  "users.deleteTitle": "Delete user",
  "users.deleteMessage": "Are you sure you want to delete \"{email}\"? This removes their account. Their uploaded videos will remain but the uploader link will be cleared.",

  // Titles
  "titles.title": "Titles",
  "titles.edit": "Edit",
  "titles.add": "Add",
  "titles.addPlaceholder": "Enter title",

  // Profile page
  "profile.title": "Profile",
  "profile.account": "Account",
  "profile.email": "Email",
  "profile.displayName": "Display name",
  "profile.displayNamePlaceholder": "Your display name",
  "profile.preferences": "Preferences",
  "profile.language": "Language",
  "profile.theme": "Theme",
  "profile.changePassword": "Change password",
  "profile.currentPassword": "Current password",
  "profile.newPassword": "New password",
  "profile.confirmPassword": "Confirm new password",
  "profile.passwordChanged": "Password changed successfully.",
  "profile.profileSaved": "Profile saved.",
  "profile.passwordMismatch": "New passwords do not match.",
  "profile.passwordTooShort": "New password must be at least 6 characters.",
};

export default en;
export type TranslationDict = { [K in keyof typeof en]: string };
